// extracted by mini-css-extract-plugin
export default {"nav":"ScreenNav_nav__wuXvc"};